import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var SegmentedTab = function SegmentedTab(_ref) {
  var label = _ref.label,
    active = _ref.active,
    onClick = _ref.onClick,
    className = _ref.className,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("button", {
    className: cx('component', {
      active: active
    }, className),
    onClick: onClick,
    style: {
      width: width
    },
    type: "button",
    "data-t-id": "Tabs-SegmentedTab"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx('text'),
    color: active ? 'primary' : 'secondary',
    size: "xs",
    tagName: "p"
  }, label));
};